"use client";

import { SubscriptionProductId } from "@jace/api";
import { trackGTMConversion } from "@jace/insights";
import confetti from "canvas-confetti";
import { useRouter, useSearchParams } from "next/navigation";
import { useEffect } from "react";

const PARAM_NAME = "subscribed";

export function getSubscriptionValue(productId: SubscriptionProductId): number {
	switch (productId) {
		case SubscriptionProductId.professional:
			return 20;
		case SubscriptionProductId.professional_yearly:
			return 200;
		case SubscriptionProductId.premium:
			return 65;
		case SubscriptionProductId.premium_yearly:
			return 650;
		default:
			return 0;
	}
}

export function addSubscriptionParamToUrl(
	url: string,
	productId: SubscriptionProductId,
): string {
	const paramValue = getSubscriptionValue(productId);
	const urlObj = new URL(url);
	const urlParams = new URLSearchParams(urlObj.search);
	urlParams.set(PARAM_NAME, paramValue.toString());
	urlObj.search = urlParams.toString();
	return urlObj.toString();
}

/**
 * Hook to check for `subscribed` URL parameter and trigger Google Ad conversion event
 */
export function useSubscriptionTracking() {
	const searchParams = useSearchParams();
	const router = useRouter();

	useEffect(() => {
		const subscriptionValue = searchParams.get(PARAM_NAME);

		if (subscriptionValue) {
			console.log(
				`Sending Google Ad conversion event with value: ${Number.parseFloat(subscriptionValue)}`,
			);
			trackGTMConversion(Number.parseFloat(subscriptionValue));

			confetti();

			// Remove the subscription parameter from the URL
			const params = new URLSearchParams(window.location.search);
			params.delete(PARAM_NAME);
			const newParams = params.toString();
			const path = window.location.pathname;
			const newPath = newParams ? `${path}?${newParams}` : path;

			router.replace(newPath);
		}
	}, [searchParams, router]);
}
